var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column is-offset-half"},[_c('div',{staticClass:"content"},[_c('self-building-square-spinner',{attrs:{"animation-duration":6000,"size":40,"color":"#0091D5"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }